import { createSlice } from '@reduxjs/toolkit'
import {
  fetchHiLoGamePendingBets,
  fetchCoinHeistGamePendingBets,
  fetchMineGamePendingBets
} from 'redux-thunk/thunk/PendingBets/pendingBets'

const initialState = {
  hiLoGamePendingBets: null,
  coinHeistGamePendingBets: null,
  mineGamePendingBets: null
}

const pendingBetsSlice = createSlice({
  name: 'pendingBetsSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchHiLoGamePendingBets.fulfilled, (state, action) => {
        return {
          ...state,
          hiLoGamePendingBets: action.payload
        }
      })
      .addCase(fetchCoinHeistGamePendingBets.fulfilled, (state, action) => {
        return {
          ...state,
          coinHeistGamePendingBets: action.payload
        }
      })
      .addCase(fetchMineGamePendingBets.fulfilled, (state, action) => {
        return {
          ...state,
          mineGamePendingBets: action.payload
        }
      })
  }
})

export default pendingBetsSlice.reducer
